import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { FilterType } from '@/api/dashboard'

export type Query = {
  campaign_versions: string

  type?: FilterType

  start_at?: number
  end_at?: number
}

export const useCampaignNodeStatQuery = (
  companyId: string,
  gameId: string,
  campaignId: string,
  query: Query,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['campaign-node-stat', gameId, campaignId, query],
    queryFn: () => dashboardClient.v1.getCampaignNodeStat({ campaignId, companyId, gameId, ...query }),
    select: response => response.data,
    enabled: enabled,
  })
}
